import { PrivateAreaView } from './components/Views';
import { PRIVATE_AREA_VIEW_ROUTE } from './constants';
import { default as Login } from '@plone/volto/components/theme/Login/Login';

const applyRoutes = (config) => {
  config.addonRoutes = [
    {
      path: ['/login', '/**/login', `/eu/${PRIVATE_AREA_VIEW_ROUTE}/login`],
      component: Login,
    },
    {
      path: `/(${config.settings?.supportedLanguages.join('|')})/${PRIVATE_AREA_VIEW_ROUTE}`,
      component: PrivateAreaView,
    },
  ];
  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    `/${PRIVATE_AREA_VIEW_ROUTE}`,
  ];
  config.settings.customizations = process.env.WEBPACK_ALIASES;

  return config;
};

export default applyRoutes;
